import React, { Component } from 'react';
import { withFormik } from 'formik';

import ChipInput from 'material-ui-chip-input';
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';

import LevelDropdown from '../../containers/DrawingTool/LevelMenu';
import { postDrawingSchema } from '../../containers/DrawingTool/schema';

import PostConfirmationModal from '../PostConfirmationModal';
import InviteFriends from '../InviteFriends';

import { searchUsers } from '../../api';
import { prepareInviteFriendsData } from '../../api/dataParsers';

import './index.scss';

class SketchForm extends Component {
  static preventDefault(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  static onBeforeTagAdd(value) {
    return !!value;
  }

  constructor(props) {
    super(props);

    this.tagsInputRef = null;
    this.inviteFriendsData = [];

    this.confirmationModalOnSubmit = this.confirmationModalOnSubmit.bind(this);
    this.onTagAddHandler = this.onTagAddHandler.bind(this);
    this.onTagCustomAddHandler = this.onTagCustomAddHandler.bind(this);
    this.onTagDeleteHandler = this.onTagDeleteHandler.bind(this);
    this.setTagsInputRef = this.setTagsInputRef.bind(this);
    this.onPostConfirmationModal = this.onPostConfirmationModal.bind(this);
    this.onCancelConfirmationModal = this.onCancelConfirmationModal.bind(this);
  }

  onPostConfirmationModal() {
    this.confirmationModalOnSubmit();
  }

  onCancelConfirmationModal() {
    const { postConfirmationModal, fetchExistingDraft, checkExistingDraftOnCancel } = this.props;
    if (fetchExistingDraft) {
      checkExistingDraftOnCancel();
    } else {
      postConfirmationModal();
    }
  }


  onTagAddHandler(newTag) {
    const { setValues, values } = this.props;
    setValues({
      ...values,
      tags: [...values.tags, newTag],
    });
  }

  onTagCustomAddHandler() {
    const inputValue = this.tagsInputRef.value;
    if (SketchForm.onBeforeTagAdd(inputValue)) {
      this.onTagAddHandler(inputValue);
    }
  }

  onTagDeleteHandler(tag, index) {
    const { setValues, values } = this.props;

    const newTagValues = [...values.tags];
    newTagValues.splice(index, 1);

    setValues({
      ...values,
      tags: newTagValues,
    });
  }

  setTagsInputRef(node) {
    this.tagsInputRef = node;
  }

  confirmationModalOnSubmit() {
    const { setValues, values, submitForm } = this.props;
    setValues({
      ...values,
      inviteFriendsData: this.inviteFriendsData,
    });
    submitForm();
  }

  render() {
    const {
      values, userLevel,
      handleChange, confirmPosting,
      isReply, setFieldValue,
      submitForm,
      isDraftAction,
      isPosting,
    } = this.props;
    const {
      title, tags,
    } = values;

    return (
      <div className="drawingCanvasControlPanel">
        <form onSubmit={SketchForm.preventDefault}>
          {!isReply ? (
            <input
              placeholder="My title..."
              margin="normal"
              name="title"
              value={title}
              maxLength="30"
              onChange={handleChange}
              className="canvasTitle"
            />
          ) : null}
          <div className="dtInteractions">
            {!isReply ? (
              <LevelDropdown
                handleChange={handleChange}
                userLevel={userLevel}
                setFieldValue={setFieldValue}
              />
            ) : null}
            <div>
              <InviteFriends
                dataFetcher={searchUsers}
                onValueChange={(values) => { this.inviteFriendsData = values; }}
              />
            </div>
            <div className="customChips">
              <ChipInput
                value={tags}
                onAdd={this.onTagAddHandler}
                onDelete={this.onTagDeleteHandler}
                allowDuplicates={false}
                clearInputValueOnChange
                placeholder="Add Tags"
                blurBehavior="ignore"
                inputRef={this.setTagsInputRef}
                className="customChipsInputField"
              />
              <button type="button" className="btn btnReset addChipBtn" onClick={this.onTagCustomAddHandler}>
                <span className="addBtnImg" />
              </button>
            </div>
            <div className="text-center">
              {
                isReply
                  ? <Button type="button" className="btnPost isReply" onClick={submitForm} />
                  : <Button type="button" className="btnPost" onClick={submitForm}>Start Conversation</Button>
              }
              <PostConfirmationModal
                open={confirmPosting}
                onPost={this.onPostConfirmationModal}
                onCancel={this.onCancelConfirmationModal}
                isDraftAction={isDraftAction}
                isPosting={isPosting}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const PostSketchForm = withFormik(
  {
    mapPropsToValues: props => ({
      title: props.title,
      level: props.userLevel,
      tags: [],
    }),
    handleSubmit: (values, { props }) => {
      const {
        userLevel, setRequestPost, openLoginForm, postConfirmationModal,
        postDrawing, activityId, isAuthenticated, confirmPosting,
      } = props;
      if (!isAuthenticated) { // if logged out then will  enter
        setRequestPost();
        openLoginForm();
        return;
      }
      const {
        title, level, tags, inviteFriendsData,
      } = values;

      if (window.dadaCanvas.isCanvasEmpty()) {
        // eslint-disable-next-line no-alert
        window.alert('your canvas is empty, plesae draw something then post');
        return;
      }

      if (!confirmPosting) { postConfirmationModal(); return; }
      window.dadaCanvas.exportCanvasBlob().then((resp) => {
        const { users, emails } = prepareInviteFriendsData(inviteFriendsData);
        const payload = postDrawingSchema(activityId, title, level || userLevel, resp, emails, users, tags);
        postDrawing(payload);
      }).catch((error) => {
        postConfirmationModal();
      });
    },
  },
)(SketchForm);

export default PostSketchForm;



// WEBPACK FOOTER //
// ./src/components/postSketchForm/index.js